//react
import React from "react";

//redux
//import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

//router
import { Redirect } from "react-router-dom";

//firebase
import { db } from 'assets/firebase';

//styles
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import landingPageStyle from "assets/jss/material-kit-pro-react/views/landingPageStyle.jsx";

// core components
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import LessonCard from "components/LessonCard/LessonCard.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import VideoCard from "components/VideoCard/VideoCard.jsx";

//images
import coverPhoto from "assets/img/kids1.png"

//icons
import Calendar from "@material-ui/icons/CalendarToday";
import Mood from "@material-ui/icons/Mood";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-139377707-1');

const dashboardRoutes = [];

function compareGrade(a,b) {

  var aName = a.GradeLevel;
  var bName = b.GradeLevel;

  if (aName < bName)
    return -1;
  if (aName > bName)
    return 1;
  return 0;
}

function compareWeek(a,b) {

  var aName = a.Week;
  var bName = b.Week;

  if (aName < bName)
    return -1;
  if (aName > bName)
    return 1;
  return 0;
}

class LessonsList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      lessons: [],
      nsgLessons: [],
      settings: { q1Enabled: false, q2Enabled: false, q3Enabled: false, q4Enabled: false}
    };

    console.log(props)
  }

  componentWillMount() {
    
    //db.getCourseByGradeLevel(this.props.user.gradeLevel).then(course => {

    db.getSettings('default').then(settings => {
      this.setState({settings: settings});
    });

      // normal All Things EQ lessons
      db.getLessonsByCourse('BmeqwyOBaiYFxePx6icj').then(snapshot => {
        
        var today = new Date();
        var nextWeek = new Date();
        nextWeek.setDate(nextWeek.getDate() + 7);
        var lastWeek = new Date();
        lastWeek.setDate(lastWeek.getDate() - 7);

        var lessons = [];
        snapshot.forEach((doc) => {

            var lesson = doc.data();

            if(lesson.ReleaseDate) {

              var releaseDate = new Date(lesson.ReleaseDate);

              //if(releaseDate < today || (this.props.user.userType !== 'student' && releaseDate < nextWeek)) {
                lesson.id = doc.id;
                if(!lesson.Photos)
                  lesson.Photos = [];

                if(releaseDate > today)
                  lesson.isPreview = true;
                else if (releaseDate > lastWeek)
                  lesson.isCurrentWeek = true;

                lessons.push(lesson);
  
              //}              
            }
        });

        lessons.sort(compareGrade);

        this.setState({lessons: lessons});
      });

      // Navigating Social Circles
      db.getLessonsByCourse('jC2E6fdSLfxApo9gGEyA').then(snapshot => {
        
        db.getVideosByType("Other").then(videos => {

          var lessons = [];
          snapshot.forEach((doc) => {
  
              var lesson = doc.data();
  
              if(lesson.IsVisible) {
  
                lesson.id = doc.id;
                if(!lesson.Photos)
                  lesson.Photos = [];

                for(var i = 0; i < videos.length; i++) {
                  if(videos[i].Quarter === lesson.Quarter 
                    && videos[i].Week === lesson.Week) {
                      lesson.video = videos[i];
                      break;
                    }
                }
  
                lessons.push(lesson);              
              }
          });
  
          lessons.sort(compareWeek);
  
          this.setState({nsgLessons: lessons});

        });
      });
    //});
  }

  enableQuarter(quarter) {
    if(this.props.user.schoolID === 'ExYodx7WZrChO0N1JDbC') {
      return true;
    } else {
      
      if(
        (this.state.settings.q1Enabled && quarter === 1) ||
        (this.state.settings.q2Enabled && quarter === 2) ||
        (this.state.settings.q3Enabled && quarter === 3) ||
        (this.state.settings.q4Enabled && quarter === 4)
      ) {
        return false;
      }
      else 
        return true;
    }
  }

  getCurrentTab() {
    if(this.props.user.schoolID === 'ExYodx7WZrChO0N1JDbC') {
      return 4;
    } else {
      return 0;
    }
  }
  
  render() {
    const { classes, ...rest } = this.props;

    if (!this.props.user) {
      return <Redirect to='/login' />
    } else if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    } 
/*
    const intercom = document.createElement("script");
    intercom.innerHTML = "window.Intercom('hide');";
    document.body.appendChild(intercom);
*/
    const intercom = document.createElement("script");
    intercom.innerHTML = 'window.Intercom("boot", { app_id: "l0gl1yia", email:"' + this.props.user.email + '", user_id: "' + this.props.user.id + '", user_type: "' + this.props.user.userType + '", companies: [ { company_id: "' + this.props.user.schoolID +'" } ] });';
    document.body.appendChild(intercom);
    
    return (

      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="All Things EQ"
          links={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "dark"
          }}
          {...rest}
        />
        <Parallax image={coverPhoto}>
          <div className={classes.container} style={{position: "static", marginBottom:"89px"}}>
            <GridContainer style={{textAlign: "center"}}>
              <GridItem xs={12} sm={12} md={12}>
                <br />
              </GridItem>
              <br /><br />
            </GridContainer>
          </div>
        </Parallax>
        
        <div className={classNames(classes.main, classes.mainRaisedHigh)} style={{backgroundColor:"#efefef", marginTop:"-250px", marginLeft:"10px", marginRight:"10px", borderRadius:"6px", minHeight:"500px"}}>
          <div className={classes.container}>
            
            <div className={classes.section} >

                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        
                        <br />

                        <h3 style={{color:"black"}} classes={[classes.title, classes.black]}>Welcome</h3>

                        <div style={{color:"#232323", marginBottom:"43px"}}>
                          Everything you need is right here at your fingertips!
                        </div>

                        <h4 style={{color:"black", marginBottom:"34px"}}>Insights</h4>
                        
                        <CustomTabs
                              headerColor="warning"
                              plainTabs
                              value={this.getCurrentTab()}
                              tabs={[
                                {
                                  tabName: "First Quarter",
                                  tabIcon: Calendar,
                                  disabled: this.enableQuarter(1),
                                  tabContent: (
                                    
                                      <GridContainer direction="row">
                                        {this.state.lessons.filter(function(obj) { return obj.Quarter===1; }).map((lesson, index) => (
                                        <LessonCard key={lesson.id} lesson={lesson} index={index} />
                                        ))}
                                      </GridContainer>
                                  )
                                },
                                {
                                  tabName: "Second Quarter",
                                  tabIcon: Calendar,
                                  disabled: this.enableQuarter(2),
                                  tabContent: (
                                    
                                      <GridContainer direction="row">
                                        {this.state.lessons.filter(function(obj) { return obj.Quarter===2; }).map((lesson, index) => (
                                        <LessonCard key={lesson.id} lesson={lesson} index={index} />
                                        ))}
                                      </GridContainer>
                                  )
                                },
                                {
                                  tabName: "Third Quarter",
                                  tabIcon: Calendar,
                                  disabled: this.enableQuarter(3),
                                  tabContent: (
                                    
                                      <GridContainer direction="row">
                                        {this.state.lessons.filter(function(obj) { return obj.Quarter===3; }).map((lesson,index) => (
                                        <LessonCard key={lesson.id} lesson={lesson} index={index} />
                                        ))}
                                      </GridContainer>
                                  )
                                },
                                {
                                  tabName: "Fourth Quarter",
                                  tabIcon: Calendar,
                                  disabled: this.enableQuarter(4),
                                  tabContent: (
                                    
                                      <GridContainer direction="row">
                                        {this.state.lessons.filter(function(obj) { return obj.Quarter===4; }).map((lesson,index) => (
                                        <LessonCard key={lesson.id} lesson={lesson} index={index} />
                                        ))}
                                      </GridContainer>
                                  )
                                }
                                ,
                                {
                                  tabName: "Navigating Social Groups",
                                  tabIcon: Mood,
                                  tabContent: (
                                    
                                      <GridContainer direction="row">
                                        {this.state.nsgLessons.map((lesson,index) => (
                                        <VideoCard key={lesson.id} lesson={lesson} index={index} />
                                        ))}
                                      </GridContainer>
                                  )
                                }
                              ]}
                            />

                        
                        
                        <br /><br /><br /><br />
                    </GridItem>
                </GridContainer>
            </div>
          </div>
        </div>

        <Footer content={
            <div>
              <div className={classes.left}>
                <List className={classes.list}>
                  <ListItem className={classes.inlineBlock}>
                    <a
                      href="https://app.allthingseq.com/"
                      className={classes.block}
                    >
                      All Things E.Q.
                    </a>
                  </ListItem>
                  
                </List>
              </div>
              <div className={classes.right} style={{fontSize:"12px", marginRight:"23px"}}>
                &copy; {1900 + new Date().getYear()}{" "}
                AVA School Solutions
              </div>
            </div>
          }/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

LessonsList = connect(mapStateToProps)(LessonsList);
export default withStyles(landingPageStyle)(LessonsList);





// WEBPACK FOOTER //
// ./src/views/LessonList/LessonList.jsx